import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

const OrganizationSwitcher = () => {
  const { user, setActiveOrganization } = useContext(AuthContext);
  const profile = user?.user || user || {};
  const organizations = profile.organizations || [];
  if (organizations.length < 2) return null;
  const active = profile.activeOrganizationId || organizations[0].organizationId;

  return (
    <label className="text-sm theme-text flex items-center gap-2">
      Organization
      <select
        aria-label="Organization"
        className="px-2 py-1 rounded border theme-text"
        style={{ borderColor: 'var(--color-border)', backgroundColor: 'var(--color-background)' }}
        value={active}
        onChange={(event) => setActiveOrganization(event.target.value)}
      >
        {organizations.map((org) => (
          <option key={org.organizationId} value={org.organizationId}>
            {org.name}
          </option>
        ))}
      </select>
    </label>
  );
};

export default OrganizationSwitcher;
